<template>
    <div class="main_container" style="position: relative;">
        <div class="detail_container" v-loading="detailLoading" style="">
            <div class="invoice_tips" v-if="!$route.query.Id">
                <i class="el-message__icon el-icon-warning"></i>
                <span>{{$t('message.Identify')}} {{myInvoice.totalInvoice}} {{$t('message.Invoice')}}，{{myInvoice.totalInvoice === 1 ? $t('message.PleaseConfirm') : $t('message.ConfirmOneByOne')}}。</span>
            </div>
            <ul class="invoice_lists">
                <li :class="[curIndex === index ? 'invoice_active' : '', myInvoice.invoiceLists.length === 1 ? 'invoice_one' : '']"
                    :key="index" class="invoice_list"
                    v-for="(invoice, index) in myInvoice.invoiceLists">
                    <div :class="(myInvoice.invoiceLists.length === 1 && $route.query.Id) ? 'invoice_tag_mt' : ''"
                         class="invoice_tag"
                         v-if="invoice.invoiceStatus !== '' || invoice.invoiceForm.changeFields.length > 0">
                        <el-tag :style="{backgroundColor: myInvoice.invoiceStatusColorRGBA, borderColor: '#' + myInvoice.invoiceStatusColor, color: '#' + myInvoice.invoiceStatusColor}"
                                v-if="invoice.invoiceStatus !== ''">
                            {{invoice.invoiceStatus.Value}}
                        </el-tag>
                        <el-tag type="warning" v-if="invoice.invoiceForm.changeFields.length > 0">
                            {{$t('message.Modified')}}
                        </el-tag>
                        <el-tooltip :content="invoice.invoiceForm.ReasonContent" class="item" effect="dark" placement="top">
                            <span>
                                <i class="iconfont icon-zhushi-kong" v-if="invoice.invoiceForm.IsDisplayReason == 1"></i>
                            </span>
                        </el-tooltip>
                    </div>
                    <div class="invoice_info" v-if="curIndex !== index">
                        <div class="invoice_info_content">
                            <div class="invoice_msg invoice_remark">
                                <span :class="{'en': $i18n.locale === 'en'}" class="msg_title">{{$t('message.InvoiceRemark')}}</span>
                                <span>{{invoice.invoiceInfo.InvoiceRemarks}}</span>
                            </div>
                            <div class="invoice_msg">
                                <span :class="{'en': $i18n.locale === 'en'}" class="msg_title">{{$t('message.InvoiceNumber')}}</span>
                                <span>{{invoice.invoiceInfo.InvoiceNumber}}</span>
                            </div>
                            <div class="invoice_msg">
                                <span :class="{'en': $i18n.locale === 'en'}" class="msg_title">{{$t('message.InvoiceType')}}</span>
                                <span>{{invoice.invoiceInfo.TypeDesc}}</span>
                            </div>
                            <div class="invoice_msg">
                                <span :class="{'en': $i18n.locale === 'en'}" class="msg_title">{{$t('message.TotalAmount')}}</span>
                                <span>{{invoice.invoiceInfo.TotalAmount}}</span>
                            </div>
                            <div class="invoice_msg err_msg" v-if="invoice.operateInfo.repetition">
                                <span>{{invoice.operateInfo.repetitionDesc}}</span>
                            </div>
                        </div>
                        <el-tooltip :content="$t('message.Edit')" class="item" effect="dark" placement="top">
                            <el-button
                                    @click="gotoEdit(index)"
                                    class="invoice_info_edit iconfont icon-bianji-kong"
                                    :type="invoice.invoiceInfo.IsPersonalInvoice == '1' ? 'primary' : 'info'"
                                    :disabled="invoice.invoiceInfo.IsPersonalInvoice == '0'"
                                    v-if="invoice.operateInfo.canEdit"
                            ></el-button>
                        </el-tooltip>
                    </div>
                    <div class="invoice_form" v-else>
                        <invoice-edit :curItem="curIndex" :invoiceData="invoice.invoiceForm" :remarkStatus="remarkStatus"
                                      @getChangeData="getChangeData" v-if="curIndex === index"></invoice-edit>
                    </div>
                </li>
            </ul>
            <div class="invoice_confirm" v-if="!$route.query.Id">
                <div class="invoice_confirm_info">{{$t('message.AlreadyEdited')}}
                    <span>{{myInvoice.changedInvoice}}</span> {{$t('message.Invoice')}}
                </div>
            </div>
        </div>
        <div class="invoice_back" style="position: fixed;z-index: 99;bottom: 0;background:#f3f3f3;width: 100%;">
            <el-tooltip :content="$t('message.Back')" class="item" effect="dark" placement="top">
                <el-button
                        @click="goBack"
                        class="iconfont icon-zuo"
                        type="primary"
                ></el-button>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {GetInvoiceDetail} from "../api/apiInvoice";
    import {setStore, getStore, removeStore, getLocal, colorRGBA} from "../config/mUtils";
    import {pdfPath} from "../config/env";
    import InvoiceEdit from "../components/invoiceEdit";

    export default {
        name: 'myInvoiceDetail',
        components: {InvoiceEdit},
        data() {
            return {
                pdfPath,
                detailLoading: false,
                curIndex: -1,
                myInvoice: {
                    invoiceStatusColor: '',
                    invoiceStatusColorRGBA: '',
                    totalInvoice: '',
                    invoiceLists: [],
                    changedInvoice: 0
                },
                remarkStatus: false
            }
        },
        created() {
            this.getLanguageResourceForPage();
            if (this.$route.query.Id) {
                this.curIndex = 0;
                this.getInvoiceDetail();
            } else {
                this.getOCRData();
            }
        },
        mounted() {
        },
        computed: {},
        watch: {},
        methods: {
            // 获取发票明细
            async getInvoiceDetail() {
                this.detailLoading = true;
                try {
                    let data = await GetInvoiceDetail(
                        this.$route.query.Id,
                        getLocal('language')
                    );
                    if (data.error_code === '0') {
                        this.detailLoading = false;
                        this.myInvoice.invoiceStatusColor = data.data.invoiceStatusColor;
                        this.myInvoice.invoiceStatusColorRGBA = colorRGBA(data.data.invoiceStatusColor);
                        this.myInvoice.totalInvoice = 1;
                        let fileInfo = data.data.fileInfo;
                        if (data.data.fileInfo.FileType.toLocaleLowerCase() === '.pdf') {
                            fileInfo.PDFUrl = pdfPath + '?file=' + encodeURIComponent(data.data.fileInfo.FileUrl);
                        }
                        this.myInvoice.invoiceLists[0] = {
                            invoiceInfo: {},
                            invoiceStatus: data.data.invoiceStatus,
                            verifiedResult: data.data.verifiedResult,
                            invoiceForm: {
                                Id: this.$route.query.Id,
                                remark: data.data.invoiceRemarks,
                                formMap: data.data.main,
                                fileInfo: fileInfo,
                                changeItems: data.data.changeItems,
                                invoiceItem: data.data.invoiceItem,
                                changeFields: data.data.changeFields,
                                errorFields: data.data.errorFieldsNew,
                                typeDesc: data.data.typeDesc,
                                IsDisplayReason: data.data.IsDisplayReason,
                                ReasonContent: data.data.ReasonContent,
                                invoiceDetailTitle: data.data.invoiceDetailTitle
                            },
                            operateInfo: {
                                canEdit: false,
                                repetition: '',
                                repetitionDesc: ''
                            }
                        }
                        if (data.data.invoiceStatus.Value === '可报销' || data.data.invoiceStatus.Value ===  '待验真' || data.data.invoiceStatus.Value ===  'To Verify' || data.data.invoiceStatus.Value === 'Valid') {
                            this.remarkStatus = true;
                        } else {
                            this.remarkStatus = false;
                        }
                    } else {
                        this.$message.error(data.message);
                        setTimeout(() => {
                            this.detailLoading = false;
                            this.$router.push('/myInvoice');
                        }, 1000);
                    }
                } catch (error) {
                    this.detailLoading = false;
                    console.log(error);
                }
            },
            // 获取OCR内容
            getOCRData() {
                let OCRData = JSON.parse(getStore('OCRData'));
                this.curIndex = OCRData.length > 1 ? -1 : 0;
                this.myInvoice.totalInvoice = OCRData.length;
                this.myInvoice.changedInvoice = (getStore('changedInvoiceIndexData') && getStore('changedInvoiceIndexData') !== []) ? JSON.parse(getStore('changedInvoiceIndexData')).length : 0;
                OCRData.forEach(ele => {
                    this.myInvoice.invoiceLists.push({
                        invoiceInfo: {
                            IsPersonalInvoice: ele.IsPersonalInvoice.Value,
                            InvoiceRemarks: ele.InvoiceRemarks.Value,
                            InvoiceNumber: ele.InvoiceNumber.Value,
                            TypeDesc: ele.TypeDesc.Value,
                            TotalAmount: ele.TotalAmount.Value.toString().indexOf('¥') > -1 ? ele.TotalAmount.Value.toString().replace('¥', '') :  ele.TotalAmount.Value
                        },
                        invoiceStatus: '',
                        verifiedResult: '',
                        invoiceForm: {
                            Id: ele.InvoiceDetailId.Value,
                            remark: {},
                            formMap: [],
                            fileInfo: {},
                            changeItems: {},
                            invoiceItem: [],
                            changeFields: [],
                            errorFields: [],
                            typeDesc: {}
                        },
                        operateInfo: {
                            canEdit: ele.CanEdit.Value === '1' ? true : false,
                            repetition: ele.Repetition.Value === '1' ? true : false,
                            repetitionDesc: ele.RepetitionDesc.Value
                        }
                    })
                });
            },
            // 显示编辑内容
            gotoEdit(index) {
                this.curIndex = index;
            },
            // 内容是否更改
            getChangeData(val) {
                if (val) {
                    if (getStore('changedInvoiceIndexData')) {
                        let changedIndexData = JSON.parse(getStore('changedInvoiceIndexData'));
                        changedIndexData.push(this.curIndex);
                        this.myInvoice.changedInvoice = [...new Set(changedIndexData)].length;
                        setStore('changedInvoiceIndexData', [...new Set(changedIndexData)]);
                    } else {
                        setStore('changedInvoiceIndexData', [this.curIndex]);
                        this.myInvoice.changedInvoice = 1;
                    }
                    this.myInvoice.invoiceLists[this.curIndex].invoiceInfo = {
                        InvoiceRemarks: val.InvoiceRemarks,
                        InvoiceNumber: val.InvoiceNumber,
                        TypeDesc: val.TypeDesc,
                        TotalAmount: val.TotalAmount
                    }
                }
            },
            // 返回首页
            goBack() {
                removeStore('changedInvoiceIndexData');
                this.$router.push('/myInvoice');
            }
        }
    }
</script>

<style scoped>
    .main_container {
        -moz-overflow: visible;
        -ms-overflow: visible;
        overflow: visible;
        overflow: initial;
    }
</style>
